// @ts-strict-ignore
import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { fulfillmentTestingCenterAdminAccessControl } from '../access-control/fulfillmentTestingCenterAdminAccess.configuration'
import { useEnableEnhancedFTC } from '../access-control/useEnableEnhancedFTC.hook'

const EnhancedOrdersPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OrdersPage" */
      '../pages/OrdersPage/page'
    )
)

const EnhancedOrderSimulationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OrderSimulationPage" */
      '../pages/OrderSimulationPage/page'
    )
)

const LegacyOrdersTablePage = lazy(
  () =>
    import(
      /* webpackChunkName: "FulfillmentTestingCenterOrdersTablePage" */
      '../pages/legacy/orders-table/FulfillmentTestingCenterOrdersTablePage'
    )
)

const LegacyOrderSimulatorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "FTCOrderSimulatorPage" */
      '../pages/legacy/order-simulator/FulfillmentTestingCenterOrderSimulatorPage'
    )
)

const OrdersPage = props => {
  const enableEnhancedFTC = useEnableEnhancedFTC()
  return enableEnhancedFTC ? (
    <EnhancedOrdersPage {...props} />
  ) : (
    <LegacyOrdersTablePage {...props} />
  )
}

const OrderSimulationPage = props => {
  const enableEnhancedFTC = useEnableEnhancedFTC()
  return enableEnhancedFTC ? (
    <EnhancedOrderSimulationPage {...props} />
  ) : (
    <LegacyOrderSimulatorPage {...props} />
  )
}

export const fulfillmentTestingCenterAdminRouter = (
  <DomainRoute
    route="app-dev-portal-fulfillment-testing-center"
    accessControl={fulfillmentTestingCenterAdminAccessControl}
  >
    {clientEnv.PUBLIC_CLIENT_ENVIRONMENT != 'production' && (
      <DashSwitch>
        <DomainRoute exact route="ftc-orders" component={OrdersPage} />
        <DomainRoute exact route="ftc-order-simulator" component={OrderSimulationPage} />
        <DomainRedirect toRoute="ftc-orders" />
        {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
      </DashSwitch>
    )}
  </DomainRoute>
)

export const enhancedFulfillmentTestingCenterAdminRouter = (
  <DomainRoute
    route="enhanced-app-dev-portal-fulfillment-testing-center"
    accessControl={fulfillmentTestingCenterAdminAccessControl}
  >
    {clientEnv.PUBLIC_CLIENT_ENVIRONMENT != 'production' && (
      <DashSwitch>
        <DomainRoute exact route="enhanced-ftc-orders" component={OrdersPage} />
        <DomainRoute exact route="enhanced-ftc-order-simulator" component={OrderSimulationPage} />
        <DomainRedirect toRoute="enhanced-ftc-orders" />
        {/* @hygen:inject router-route 
      injection point for routes, please do not delete */}
      </DashSwitch>
    )}
  </DomainRoute>
)
